import React from 'react';
import { I18n } from 'common/i18n';
import { ForgeIconButton, ForgeIcon } from '@tylertech/forge-react';
import classNames from 'classnames';

const scope = 'shared.visualizations.panes.presentation.fields.ag_updated_column_format.conditional_options';

interface ConditionalTitleElementProps {
  index: number;
  totalConditions: number;
  onDelete: () => void;
}

const ConditionalTitleElement: React.FC<ConditionalTitleElementProps> = ({
  index,
  totalConditions,
  onDelete,
}) => {
  const headerTitleText = I18n.t('config_title', { scope });

  const headerClassName = classNames('conditional-config-title-wrapper', {
    'single-condition': totalConditions === 1,
  });

  return (
    <div className={headerClassName}>
      {totalConditions > 1 && (
        <span className="conditional-config-header-title" slot="leading">
          {headerTitleText} {index + 1}
        </span>
      )}
      <ForgeIconButton
        densityLevel={3}
        slot="trailing"
        data-testid="delete-condition-btn"
        className="delete-condition"
        dense
        onClick={onDelete}
      >
        <ForgeIcon name="close" />
      </ForgeIconButton>
    </div>
  );
};

export default ConditionalTitleElement;
